import Box from '@mui/material/Box';
import PrintPromoHeader from '@Components/PrintPromo/PrintPromoHeader';

const PrintPromoLayout = ({ children, currentPage, ...props }) => {
	return (
		<>
			<a href="#main-content" className="skip-nav">Skip to main content</a>
			<PrintPromoHeader
				logoUrl={props.LogoURL}
				logoAltText={props.LogoAltText}
				navigationLinks={props.NavigationLinks}
				quoteUrl={props.QuoteURL}
				homeUrl={props.HomeURL}
				currentPage={currentPage}
			/>
			<Box component="main" id="main-content">
				{children}
			</Box>
			</>
	);
};

export default PrintPromoLayout;
